// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"be2dc178","330":"be2dc178","345":"be2dc178","452":"be2dc178","468":"be2dc178"}[chunkId] + ".chunk.css";
};